export enum UserEndPoint {
  GetId = 'user/id/',
  GetName = 'user/fio/',
  GetList = 'users/get/',
  GetListActive = 'active/users/get/',
  GetGroups = 'users/groups/tbl/get/',
  GetRoles = 'current/user/roles/tbl/get/',
}
